// extracted by mini-css-extract-plugin
export default {"container":"Addresses_container__YdgqF"};